<!-- USEFULL SVG DEFINITION -->
<div class="egc-svg-templates">
  <svg>
    <defs>
      <pattern id="pattern-unselectable" patternUnits="userSpaceOnUse" width="20" height="20">
        <image href="assets/images/pattern-diagonal-bars-small-brown2.png" x="0" y="0" width="20" height="20" />
      </pattern>
      <pattern id="pattern-diagonal-hatch" width="10" height="10" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="10" style="stroke:black; stroke-width:2" />
      </pattern>
      <pattern id="pattern-vertical-hatch" width="10" height="10" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="10" style="stroke:black; stroke-width:2" />
      </pattern>
      <pattern id="pattern-horizontal-hatch" width="10" height="10" patternTransform="rotate(90 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="10" style="stroke:black; stroke-width:2" />
      </pattern>
      <pattern id="pattern-diagonal2-hatch" width="10" height="10" patternTransform="rotate(-45 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="10" style="stroke:black; stroke-width:2" />
      </pattern>
      <pattern id="pattern-diagonal3-hatch" width="10" height="10" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="10" stroke-dasharray="20,10,5,5,5,10" style="stroke:black; stroke-width:2;stroke-dasharray: 5,5,2,2;" />
      </pattern>
      <pattern id="pattern-diagonal4-hatch" width="10" height="10" patternTransform="rotate(90 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="10" stroke-dasharray="20,10,5,5,5,10" style="stroke: black; stroke-width: 2; stroke-dasharray: 5,2;" />
      </pattern>

      <!-- Crystal Grace: viewBox ~3.4x smaller than Serenity; same hatch tiles look too coarse -->
      <pattern id="pattern-diagonal-hatch-cg" width="3" height="3" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="3" style="stroke:black; stroke-width:0.6" />
      </pattern>
      <pattern id="pattern-vertical-hatch-cg" width="3" height="3" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="3" style="stroke:black; stroke-width:0.6" />
      </pattern>
      <pattern id="pattern-horizontal-hatch-cg" width="3" height="3" patternTransform="rotate(90 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="3" style="stroke:black; stroke-width:0.6" />
      </pattern>
      <pattern id="pattern-diagonal2-hatch-cg" width="3" height="3" patternTransform="rotate(-45 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="3" style="stroke:black; stroke-width:0.6" />
      </pattern>
      <pattern id="pattern-diagonal3-hatch-cg" width="3" height="3" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="3" style="stroke:black; stroke-width:0.6; stroke-dasharray: 1.5,1.5,0.6,0.6;" />
      </pattern>
      <pattern id="pattern-diagonal4-hatch-cg" width="3" height="3" patternTransform="rotate(90 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="3" style="stroke:black; stroke-width:0.6; stroke-dasharray: 1.5,0.6;" />
      </pattern>

      <pattern id="pattern-diagonal-hatch2" width="9" height="9" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="3" y1="0" x2="3" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="6" y1="0" x2="6" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="9" y1="0" x2="9" y2="9" style="stroke: black; stroke-width: 1;"></line>
      </pattern>
      <pattern id="pattern-diagonal-hatch2" width="9" height="9" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="3" y1="0" x2="3" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="6" y1="0" x2="6" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="9" y1="0" x2="9" y2="9" style="stroke: black; stroke-width: 1;"></line>
      </pattern>
      <pattern id="pattern-vertical-hatch2" width="9" height="9" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="3" y1="0" x2="3" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="6" y1="0" x2="6" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="9" y1="0" x2="9" y2="9" style="stroke: black; stroke-width: 1;"></line>
      </pattern>
      <pattern id="pattern-horizontal-hatch2" width="9" height="9" patternTransform="rotate(90 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="3" y1="0" x2="3" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="6" y1="0" x2="6" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="9" y1="0" x2="9" y2="9" style="stroke: black; stroke-width: 1;"></line>
      </pattern>
      <pattern id="pattern-diagonal2-hatch2" width="9" height="9" patternTransform="rotate(-45 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="3" y1="0" x2="3" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="6" y1="0" x2="6" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="9" y1="0" x2="9" y2="9" style="stroke: black; stroke-width: 1;"></line>
      </pattern>
      <pattern id="pattern-diagonal3-hatch2" width="9" height="9" patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="3" y1="0" x2="3" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="6" y1="0" x2="6" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="9" y1="0" x2="9" y2="9" style="stroke: black; stroke-width: 1;"></line>
      </pattern>
      <pattern id="pattern-diagonal4-hatch2" width="9" height="9" patternTransform="rotate(90 0 0)" patternUnits="userSpaceOnUse">
        <line x1="0" y1="0" x2="0" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="3" y1="0" x2="3" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="6" y1="0" x2="6" y2="9" style="stroke: black; stroke-width: 1;"></line>
        <line x1="9" y1="0" x2="9" y2="9" style="stroke: black; stroke-width: 1;"></line>
      </pattern>

      <pattern id="pattern-reserved" patternUnits="userSpaceOnUse" width="20" height="20">
        <image href="assets/images/pattern-horizontal-bars-small-black.png" x="0" y="0" width="20" height="20" />
      </pattern>

      <pattern id="egc-icon-wheelchair">
        <g><path d="M8 10.341v2.194C6.804 13.227 6 14.52 6 16c0 2.21 1.79 4 4 4 1.48 0 2.773-.804 3.465-2h2.193c-.823 2.33-3.046 4-5.658 4-3.314 0-6-2.686-6-6 0-2.613 1.67-4.835 4-5.659zM12 17c-1.657 0-3-1.343-3-3v-4c0-1.657 1.343-3 3-3s3 1.343 3 3v5h1.434c.648 0 1.253.314 1.626.836l.089.135 2.708 4.515-1.714 1.028L16.433 17H12zm0-15c1.38 0 2.5 1.12 2.5 2.5S13.38 7 12 7 9.5 5.88 9.5 4.5 10.62 2 12 2z"/></g>
      </pattern>
    </defs>
  </svg>
</div>
<!-- USEFULL SVG DEFINITION -->


<div class="egc-hide">
  <ng-content></ng-content>
</div>

<!-- TOOLTIP CONTENT PROJECTION -->
<div id="{{id}}-tooltip" class="egc-tooltip">
  <ng-content select="[egc-tooltip]"></ng-content>
</div>
<!-- TOOLTIP CONTENT PROJECTION -->

<!-- DECKPLAN LEGEND CONTAINER -->
<div class="egc-legend">
  <ng-content select="[egc-legend]"></ng-content>
</div>
<!-- DECKPLAN LEGEND CONTAINER -->

<!-- DECKPLAN CONTAINER -->
<div [style.display]="onConfigure ? 'block' : 'none'"
  class="egc-loader">
  <h2>...deckplan loading</h2>

  <eidos-progress-spinner class="change-password-request-spinner" [diameter]="80"></eidos-progress-spinner>
</div>
<div [id]="id" [style.visibility]="onConfigure ? 'hidden' : 'visible'"
  class="egc-container"
  [style.--egc-selectable-stroke]="cabinStrokeWidths?.selectable"
  [style.--egc-selected-stroke]="cabinStrokeWidths?.selected"
  [style.--egc-connected-stroke]="cabinStrokeWidths?.connected"
  [style.--egc-unselectable-stroke]="cabinStrokeWidths?.unselectable"
  [style.--egc-reserved-stroke]="cabinStrokeWidths?.reserved"
  [style.--egc-actual-reserved-stroke]="cabinStrokeWidths?.actualReserved"
  [style.--egc-unselectable-fill]="cabinStatusFills?.unselectable"
  [style.--egc-reserved-fill]="cabinStatusFills?.reserved"
  [style.--egc-actual-reserved-fill]="cabinStatusFills?.actualReserved"
></div>

